export default "__VITE_PUBLIC_ASSET__361b5905__"